
export default {
  // 所有办理流程字段
  handleWayList: [
    {
      label: '办理流程',
      key: 'process',
    },
    {
      label: '所需资料',
      key: 'material',
    },
    {
      label: '办理费用',
      key: 'fee_desc',
    },
  ],

  // 签证属性
  visaAttrList: [
    {
      label: '有效期限',
      key: 'validity_period',
    },
    {
      label: '最长停留',
      key: 'max_stay_duration',
    },
    {
      label: '入境次数',
      key: 'entry_num',
    },
    {
      label: '签证形式',
      key: 'visa_form',
    },
  ],


  // 去除非空内容字段
  removeEmptyKey(obj) {
    if (!obj || Object.prototype.toString.call(obj) !== '[object Object]') return;
    return Object.keys(obj).filter(key => obj[key]);
  },
  // 签证属性
  getVisaAttr(visaAttr) {
    const keyList = this.removeEmptyKey(visaAttr) || [];
    const list = [];
    keyList.forEach((key) => {
      if (visaAttr[key]) {
        const step = this.visaAttrList.find(item => item.key === key);
        list.push({
          ...step,
          content: visaAttr[key],
        });
      }
    });
    return list;
  },
  // 获取办理流程
  getHandleWay(handleWay) {
    const keyList = this.removeEmptyKey(handleWay) || [];
    const list = [];
    keyList.forEach((key) => {
      if (handleWay[key]) {
        const step = this.handleWayList.find(item => item.key === key);
        list.push({
          ...step,
          content: handleWay[key],
        });
      }
    });
    return list;
  },


};



// WEBPACK FOOTER //
// ./src/pages/country/services/country-visa-strategy-service.js